export default "__VITE_ASSET__OvE4osEc__ 300w, __VITE_ASSET__CFfQCgjQ__ 500w, __VITE_ASSET__mkvrDNif__ 800w";